import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.css']
})
export class UnauthorizedComponent implements OnInit, OnDestroy {
  public role: string;
  constructor(private location: Location, private auth: AuthServiceService, private router: Router) {
    this.role = this.auth.getRole();
  }

  ngOnInit() {
    document.body.style.backgroundColor = '#3359BE';
  }

  ngOnDestroy() {
    document.body.style.backgroundColor = 'white';
  }
  
  cancel() {
    // localStorage.clear();
    this.router.navigate(['/login']);
  }
}
